<template>
  <v-layout align-center justify-end>
    <v-btn
      icon
      v-if="$isAllowed('view', 'Search')"
      @click="onMenuItemClick(searchRouteName)"
      class="ma-1"
      :title="$t('headerToolbarActions.searchTitle')"
      small
    >
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn
      small
      icon
      v-if="$isAllowed('view', 'SubordinateWorkload')"
      @click="onMenuItemClick('workload', {
        pageNumber: 1,
        pageSize: 10,
        filter: '',
      })"
      :title="$t('headerToolbarActions.workloadTitle')"
    >
      <v-icon>view_quilt</v-icon>
    </v-btn>
    <v-btn
      small
      v-if="$isAllowed('view', 'AssignedPurchaseOrders')"
      icon
      @click="onMenuItemClick('mylist')"
      class="ma-1"
      :title="$t('headerToolbarActions.myPosListTitle')"
    >
      <v-icon>assignment</v-icon>
    </v-btn>
    <v-btn
      small
      v-if="$isAllowed('view', 'UsersManagement')"
      icon
      @click="onMenuItemClick('users')"
      class="ma-1"
      :title="$t('headerToolbarActions.usersManagementTitle')"
    >
      <v-icon>people_outline</v-icon>
    </v-btn>
    <UserMenu
      v-if="mainRole"
      :userName="userName"
      :userNameFirstLetter="userNameFirstLetter"
      :role="mainRole"
      @logout="logout"
    />
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Auth from '@/store/modules/auth/constants';
import UserMenu from '@/components/common/UserMenu.vue';
import RolesHelper from '@/helpers/rolesHelper';

export default {
  name: 'headerToolbarActions',
  components: {
    UserMenu,
  },
  data() {
    return {
      menu: false,
    };
  },
  computed: {
    ...mapState({
      userName: (state) => state.auth.userInfo.name,
    }),
    ...mapGetters('auth', {
      userNameFirstLetter: Auth.getterTypes.userNameFirstLetter,
      mainRole: Auth.getterTypes.mainRole,
    }),
    searchRouteName() {
      return RolesHelper.getRoleSearchRouteName([this.mainRole]);
    },
  },
  methods: {
    onMenuItemClick(toRoute, query) {
      this.$router.push({
        name: toRoute,
        query: {
          ...query,
        },
      });
    },
    logout() {
      this.logoutUser().then(() => {
        this.$router.push({ name: 'login' });
      });
    },
    ...mapActions(
      'auth',
      {
        logoutUser: Auth.actionTypes.logoutUser,
      },
    ),
  },
};
</script>

<i18n>
{
  "en": {
    "headerToolbarActions": {
      "searchTitle": "Search Purchase Order",
      "usersManagementTitle": "Users Management",
      "myPosListTitle": "My Assigned Purchase Orders",
      "workloadTitle": "Subordinates Workload"
    }
  }
}
</i18n>
